
const Definition = {

    plan_level: 1,
    id: "launchpad",
    name: "Launchpad",
    path: "member/launchpad/components/Landing",
    preview_image: "https://img.freepik.com/free-vector/gradient-rocket-background_23-2148146034.jpg?semt=ais_hybrid&w=740&q=80",
    colors: {
        background: "#0A0A0F",
        background_alt: "#111118",
        surface: "#1A1A24",
        surface_alt: "#22222E",
        header_background: "#0a0a0fed",
        text: "#E8E8F0",
        text_muted: "#9f9fb4",
        primary: "#C9A84C",
        primary_light: "#E8C96A",
        accent: "#4F6EF7",
        success: "#22C55E",
        danger: "#EF4444"
    },
    legacy_color_keys: {
        background: "main_color1",
        background_alt: "main_color2",
        surface: "main_color3",
        surface_alt: "main_color4",
        header_background: "header_bg",
        text: "text_color",
        text_muted: "muted",
        primary: "primary_color",
        primary_light: "primary_color_light",
        success: "green",
        danger: "red"
    }

};

export default Definition;
